import { Component } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { APIError } from "../../shared.models";
import { User } from "../../models/user.model";
import { UserService } from "../../services/user.service";
import { UtilsService } from "../../utils/utils.service";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})
export class RegisterComponent {
  user: User = new User();
  apiError: APIError = new APIError();
  termsAndConditionsChecked: boolean;
  userCreationSuccess: boolean = false;
  passwordCheck: string;
  onDestroy$ = new Subject();

  constructor(
    private userService: UserService,
    private utilsService: UtilsService
  ) {}

  /***
   * Registers a new user with the app
   */
  register() {
    this.apiError = new APIError();
    // Convert email address to uppercase to prevent users signing up with multiple versions of the same email address
    this.user.emailAddress = this.user.emailAddress.toLowerCase();
    // Trim any white spaces
    this.user.firstName = this.user.firstName.trim();
    this.user.lastName = this.user.lastName.trim();
    this.userService
      .createRegisteredUser(this.user)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.userCreationSuccess = true;
        },
        (error) => {
          this.userCreationSuccess = false;
          this.apiError = this.utilsService.handleAPIError(error);
        }
      );
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
